import { Modal, ModalWidth } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type RecordingConsentGateProps = {
   open: boolean;
   onConfirm: VoidFunction;
   onCancel: VoidFunction;
};

/**
 * RecordingConsentGate — modal dialog requiring the doctor to confirm
 * patient consent before recording starts.
 * Rendered conditionally — only mounted when open, never uses visibility prop.
 */
export const RecordingConsentGate = (props: RecordingConsentGateProps): JSX.Element | null => {
   if (!props.open) {
      return null;
   }
   return (
      <Modal
         testId={'recordingConsentGate'}
         title={translationKeys.consentGate.title}
         onCancel={props.onCancel}
         onConfirm={props.onConfirm}
         confirmationButtonLabel={translationKeys.consentGate.confirm}
         cancelButtonLabel={translationKeys.consentGate.cancel}
         width={ModalWidth.NARROW}
         shouldCloseOnEsc
         shouldCloseOnOverlayClick
      >
         <Translate>{translationKeys.consentGate.message}</Translate>
      </Modal>
   );
};
